// extracted by mini-css-extract-plugin
export default {"preview-wrapper":"PreviewWrapper_preview-wrapper__3i7kF"};